var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"primary":"","disabled":_vm.pending},on:{"click":_vm.createGoogleAdsChannel}},[_vm._v(" Add Google Ads Channel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }